import React from 'react'
import HeaderMain from '../../../Compoents/HeaderMain';
import BreadcrumbArea from '../../../ShearOne/BreadcrumbArea';
import FooterWhite from '../../../Compoents/FooterWhite';
import { Link } from 'react-router-dom';


export const HealthcareSurvey = () => {
    const breadcrumbLinks = [
        { path: '/', label: 'Home' },
        { label: 'Healthcare Survey', active: true }
      ];
      return (
        <>
        <HeaderMain/>
        <main>
       
       <BreadcrumbArea 
         title="Healthcare Survey" 
         backgroundImage="/assets/imgs/breadcrumb/page-header-1.png" 
         links={breadcrumbLinks} 
       />
<section class="service-details section-space">
    <div class="container">
        <div class="row flex-xl-row flex-column-reverse">
            <div class="col-xl-4">
                <div class="sidebar sidebar-rr-sticky">
                    <div class="sidebar__widget-service mb-30">
                        <Link to="/service">Medical Device Manufacturers <i class="fa-solid fa-plus"></i></Link>
                        <Link to="/pharmaceutical-details">Pharmaceutical & Biotech industry<i class="fa-solid fa-plus"></i></Link>
                        <Link to="/healthcare-details">Healthcare Providers <i class="fa-solid fa-plus"></i></Link>
                    </div>

                    <div class="sidebar__widget-contact__service text-center">
                        <h4 class="mb-25 title-animation text-capitalize">Are You ready to contact with us</h4>
                        <p class="mb-20"><a href="tel:+86 19811976744"><i class="fa-solid fa-phone"></i>(+86) 19811976744</a></p>
                        <Link to="/contact-us#" class="rr-btn">
                            <span class="btn-wrap">
                                <span class="text-one">Contact Us <i class="fa-solid fa-plus"></i></span>
                                <span class="text-two">Contact Us <i class="fa-solid fa-plus"></i></span>
                            </span>
                        </Link>
                    </div>
                </div>
            </div>
            <div class="col-xl-8">
                <div class="service-details__content">
                    <div class="service-details__content-media mb-20">
                        <img src="./assets/imgs/service-details/service-details-1.jpg" class="img-fluid" alt="img not found"/>
                    </div>

                    <h2 class="title-animation mb-20">Healthcare Providers</h2>
                    <p class="mb-20">SQUARE MEDTECH team is a mixture of trained healthcare professionals with various specialties, combining clinical expertise with engineering backgrounds for MedTech development. Our experienced team specializes in clinical research, regulatory affairs, data management, and patient care.</p>
                    
                    <h3 class="title-animation mb-10">How SQUARE MEDTECH Can Support Healthcare Providers</h3>
                    <p class="mb-30">We provide specialized support focused on research, regulatory compliance, and data management solutions to ensure tailored services for healthcare providers.</p>
                    
                    <ul class="mb-40">
                        <li><span><i class="fa-solid fa-check"></i></span><h5>Healthcare Research & Development Consultancy</h5></li>
                        <li><span><i class="fa-solid fa-check"></i></span><h5>Customized Solutions for Clinical Research Consultancy</h5></li>
                        <li><span><i class="fa-solid fa-check"></i></span><h5>Regulatory Consultancy for Local & Global Standards</h5></li>
                        <li><span><i class="fa-solid fa-check"></i></span><h5>Streamline Data Management Consultancy</h5></li>
                    </ul>
                    
                    <h3 class="title-animation mb-10">Healthcare Survey</h3>
                    <p class="mb-30">A healthcare survey gathers data from patients, providers, or other stakeholders to assess healthcare delivery, patient experiences, or treatment outcomes. These insights improve healthcare services, guide policies, and enhance patient care.</p>
                    
                    <h3 class="title-animation mb-10">Who Benefits from Healthcare Survey Consulting?</h3>
                    <ul class="mb-40">
                        <li><span><i class="fa-solid fa-check"></i></span><h5>Healthcare Providers: Improve patient satisfaction, treatment outcomes, and service quality.</h5></li>
                        <li><span><i class="fa-solid fa-check"></i></span><h5>Medical Device Companies: Gather user feedback and ensure regulatory compliance.</h5></li>
                        <li><span><i class="fa-solid fa-check"></i></span><h5>Hospitals and Clinics: Identify operational improvements and enhance patient safety.</h5></li>
                        <li><span><i class="fa-solid fa-check"></i></span><h5>Pharmaceutical Companies: Evaluate medications and treatment effectiveness.</h5></li>
                        <li><span><i class="fa-solid fa-check"></i></span><h5>Regulatory Bodies: Utilize accurate data for policy development.</h5></li>
                        <li><span><i class="fa-solid fa-check"></i></span><h5>Patients: Receive improved healthcare services based on survey feedback.</h5></li>
                    </ul>
                    
                    <h3 class="title-animation mb-10">How SQUARE MEDTECH Supports Healthcare Surveys</h3>
                    <ul class="mb-40">
                        <li><span><i class="fa-solid fa-check"></i></span><h5>Tailored survey design and development consulting</h5></li>
                        <li><span><i class="fa-solid fa-check"></i></span><h5>Comprehensive questionnaire creation consulting</h5></li>
                        <li><span><i class="fa-solid fa-check"></i></span><h5>Patient and provider engagement strategies consulting</h5></li>
                        <li><span><i class="fa-solid fa-check"></i></span><h5>Accurate sample size determination and statistical analysis consulting</h5></li>
                    </ul>
                    
                    <div class="row">
                        <div class="col-lg-7">
                            <div class="service-details__content-media-item">
                                <div class="service-details__content-media-item_img mb-10">
                                    <img src="./assets/imgs/service-details/service-details-2.jpg" class="img-fluid" alt="img not found"/>
                                </div>
                                <h4 class="title-animation mb-15">Data Management Consultancy</h4>
                                <p>We optimize data collection, integration, and analysis to ensure accurate, compliant, and actionable insights, streamlining healthcare research and decision-making.</p>
                            </div>
                        </div>
                        <div class="col-lg-5">
                            <div class="service-details__content-media-item">
                                <div class="service-details__content-media-item_img mb-10">
                                    <img src="./assets/imgs/service-details/service-details-3.jpg" class="img-fluid" alt="img not found"/>
                                </div>
                                <h4 class="title-animation mb-15">Our Expertise in Healthcare Providers</h4>
                                <p>We combine regulatory expertise with specialized skills to support healthcare providers, ensuring seamless project execution and compliance with industry standards.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

    </main>


    <section class="footer__cta footer__cta-bottom-up">
    <div class="container">
        <div class="row mb-minus-30">
            <div class="col-md-6">
                <div class="footer__cta-item mb-30 theme-bg-primary d-flex flex-lg-row flex-column align-items-lg-center">
                    <div class="footer__cta-item-icon d-flex align-items-center justify-content-center">
                        <img class="img-fluid" src="/assets/imgs/footer__cta/footer__cta-item-1.png" alt="icon not found"/>
                    </div>

                    <div class="footer__cta-item-text">
                    <h4 class="color-white mb-15 mb-10">Our Solutions for Healthcare Providers</h4>
                    <ul class="color-white mb-0">
                      <li>Survey Design Consultations</li>
                      <li>Statistical Analysis Consulting</li>
                      <li>Questionnaire Creation Consulting</li>
                    </ul>

                    </div>
                </div>
            </div>

            <div class="col-md-6">
                <div class="footer__cta-item mb-30 theme-bg-glow d-flex flex-lg-row flex-column align-items-lg-center">
                    <div class="footer__cta-item-icon d-flex align-items-center justify-content-center">
                        <img class="img-fluid" src="/assets/imgs/footer__cta/footer__cta-item-2.png" alt="icon not found"/>
                    </div>

                    <div class="footer__cta-item-text">
                    <h4 class="color-white mb-15 mb-10">Our Service for Healthcare Providers</h4>
                    <ul class="color-white mb-0">
                    <li>Sample size Consulting</li>
                    <li>Patient strategies Consulting</li>
                    <li>Provider strategies Consulting</li>
                  </ul>


                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
    <FooterWhite/>

    </>
  )
}
